import React from "react";
import Apply from "../../components/templates/landing/Apply";
import Dedication from "../../components/templates/landing/Dedication/Dedication-Approved";
import About from "../../components/templates/landing/About";
import DetailsButton from "../../components/templates/landing/DetailsButton";
import Layout from "../../layouts/landing";
import Approval from "../../components/templates/landing/Apply/Approval";
import aboutImage from "../../assets/landing/about.png";
import { Theme } from "./styles";
import dedication from "../../assets/landing/dedication.jpeg";
import { ReactComponent as Logo } from "../../assets/landing/logo-small.svg";

const title = (
  <>
    <Logo /> WE ARE PATRIA LENDING
  </>
);

const Landing = () => {
  return (
    <Theme>
      <Layout>
        <Apply sectionOne={<Approval />} />
        <Dedication image={dedication} />
        <About image={aboutImage} title={title} companyName="Patria Lending" />
        <DetailsButton />
      </Layout>
    </Theme>
  );
};

export default Landing;
